import React, { Component } from "react";
import { Row, Col } from "antd";
import RmxImg from "../../assets/images/rmx-step.png";
import { connect } from "react-redux";
import { UserAction, AuthAction } from "../../store/actions";

class WelcomeContainer extends Component {
  componentDidMount() {
    const userId = JSON.parse(localStorage.getItem("trkr_Auth"))?.[2]
      ?.rmx_company_user?.id;
    this.props.getUserDetail(userId);
  }
  render() {
    console.log("hhh=>", this.props.userDetails);
    return (
      <Row>
      
        <Row justify="center">
          <Col xl={24} lg={24} xs={1} sm={12} md={12}>
            <a href="https://surface-tech.com/etools/trkr-video/">
              <img src={RmxImg} style={{ objectFit:'cover' }} width={'113%'}  />
            </a>
          </Col>
        </Row>
      </Row>
    );
  }
}

const mapStateToProps = (store) => {
  return {
    userDetails: store.UserReducer.userDetails,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getUserDetail: (userId) => dispatch(UserAction.getUserDetailReq(userId)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(WelcomeContainer);
